import React from 'react'
import "./overview.css"
import { Check, EyeIcon, RupeesIcon, TriangleExclamation, Download, Upload, FileLines, Cross, CircleExclamation, Calculator, Signature } from '../../../../components/icons/Icons'
import GlobalCard from '../components/GlobalCard'
import { Row, Col, Card } from 'react-bootstrap'
import DoughnutChart from '../../../../components/Charts/DoughnutChart'
import LineChart from '../../../../components/Charts/LineChart'

const Overview = ({declaration, documentFieldsMetadata, tdsCalculation, regimeType}) => {

  console.log("declaration ------> ", declaration)

  const hraDeclaration = [
    { id: 1, label: 'HRA Declaration', value: '25,000', icon: <Check />,isHr: false, isH3: true, isLabel: false, isBadge: true, classname: "badge-green", isLinkBtn: false, badgeText: "Submitted" },
    { id: 2, label: 'Monthly Rent', value: declaration.monthlyRent, icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 3, label: 'Annual Rent', value: declaration.annualAmount, icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 4, label: 'Landlord PAN', value: declaration.landlordPan, icon: "", isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 5, label: '', value: '', icon: <RupeesIcon />, isHr: true, isH3: false, isLabel: false, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 6, label: 'HRA Exemption', value: '25,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "text-green", isLinkBtn: false },
    { id: 7, label: 'View Rent Receipt Tracker', value: '25,000', icon: <EyeIcon />, isHr: false, isH3: false, isLabel: false, isBadge: false, classname: "text-purple", isLinkBtn: true },
  ]

  const homeLoan = [
    { id: 1, label: 'Home Loan Interest', value: 'Pending Proof', icon: <TriangleExclamation />, isHr: false, isH3: true, isLabel: false, isBadge: true, classname: "badge-yellow", isLinkBtn: false, badgeText: "Pending Proof" },
    { id: 2, label: 'Declared Amount', value: declaration.lenderPaidAmount, icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 3, label: 'Lender', value: 'HDFC Bank', icon: null, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 4, label: 'Loan Account', value: '****7890', icon: "", isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 5, label: '', value: '', icon: <RupeesIcon />, isHr: true, isH3: false, isLabel: false, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 6, label: 'Allowed (Section 24)', value: 'pending', icon: "", isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "yellow-text", isLinkBtn: false },
    { id: 7, label: 'Upload Interest Certificate', value: '25,000', icon: <Upload />, isHr: false, isH3: false, isLabel: false, isBadge: false, classname: "text-purple", isLinkBtn: true },
  ]

  const section80c = [
    { id: 1, label: 'Section 80C Deductions', value: '25,000', icon: <Check />, isHr: false, isH3: true, isLabel: false, isBadge: true, classname: "badge-green", isLinkBtn: false, badgeText: "Verified" },
    { id: 2, label: 'Invest Amount', value: declaration.s80CInvestAmount, icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 3, label: 'ELSS Mutual Funds', value: '50,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 4, label: 'Life Insurance', value: '25,000', icon: "", isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 5, label: '', value: '', icon: <RupeesIcon />, isHr: true, isH3: false, isLabel: false, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 6, label: 'Total Allowed', value: '1,50,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "text-green", isLinkBtn: false },
    { id: 7, label: 'View All Certificates', value: '', icon: <FileLines />, isHr: false, isH3: false, isLabel: false, isBadge: false, classname: "text-purple", isLinkBtn: true },
  ]

  const section80d = [
    { id: 1, label: 'Section 80D Medical', value: '25,000', icon: <Cross />, isHr: false, isH3: true, isLabel: false, isBadge: true, classname: "badge-red", isLinkBtn: false, badgeText: "Missing" },
    { id: 2, label: 'Premium Amount', value: declaration.s80DPremiumAmount, icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 3, label: 'Parents', value: '25,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 4, label: 'Health Checkup', value: 'ABCDE1234F', icon: "", isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 5, label: '', value: '', icon: <RupeesIcon />, isHr: true, isH3: false, isLabel: false, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 6, label: 'Total Declared', value: '25,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "text-red", isLinkBtn: false },
    { id: 7, label: 'Upload Premium Receipts', value: '25,000', icon: <CircleExclamation />, isHr: false, isH3: false, isLabel: false, isBadge: false, classname: "text-red", isLinkBtn: true },
  ]

  const section80e = [
    { id: 1, label: 'Section 80E', value: '', icon: <Cross />, isHr: false, isH3: true, isLabel: false, isBadge: true, classname: "badge-red", isLinkBtn: false, badgeText: "Missing" },
    { id: 2, label: 'Interest Amount', value: declaration.s80EInterestAmount, icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 3, label: 'Parents', value: '25,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 4, label: 'Health Checkup', value: 'ABCDE1234F', icon: "", isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 5, label: '', value: '', icon: <RupeesIcon />, isHr: true, isH3: false, isLabel: false, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 6, label: 'Total Declared', value: '25,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "text-red", isLinkBtn: false },
    { id: 7, label: 'Upload Premium Receipts', value: '25,000', icon: <CircleExclamation />, isHr: false, isH3: false, isLabel: false, isBadge: false, classname: "text-red", isLinkBtn: true },
  ]

  const section80g = [
    { id: 1, label: 'Section 80E', value: '', icon: <Cross />, isHr: false, isH3: true, isLabel: false, isBadge: true, classname: "badge-red", isLinkBtn: false, badgeText: "Missing" },
    { id: 2, label: 'Donation Amount', value: declaration.s80GDonationAmount, icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 3, label: 'Parents', value: '25,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 4, label: 'Health Checkup', value: 'ABCDE1234F', icon: "", isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 5, label: '', value: '', icon: <RupeesIcon />, isHr: true, isH3: false, isLabel: false, isBadge: false, classname: "color-white", isLinkBtn: false },
    { id: 6, label: 'Total Declared', value: '25,000', icon: <RupeesIcon />, isHr: false, isH3: false, isLabel: true, isBadge: false, classname: "text-red", isLinkBtn: false },
    { id: 7, label: 'Upload Premium Receipts', value: '25,000', icon: <CircleExclamation />, isHr: false, isH3: false, isLabel: false, isBadge: false, classname: "text-red", isLinkBtn: true },
  ]

  return (
    <div>
      <Row className='mt-3'>
        <GlobalCard data={hraDeclaration} />
        <GlobalCard data={homeLoan} />
        <GlobalCard data={section80c} />
        <GlobalCard data={section80d} />
        <GlobalCard data={section80e} />
        <GlobalCard data={section80g} />
      </Row> 

      {/* Bottom Section - Charts and Summary */}
      <Row className="mb-4">
        {/* Declared vs Allowed Chart */}
        <Col lg={4} className="mb-3">
          <div className="emp-tds-card" style={{ height: "300px", width: "100%" }}>
            <h3 className="chart-title color-white">Declared vs Allowed</h3>
            <div className="d-flex align-items-center justify-content-center" style={{ height: "250px", width: "100%" }}>
              <DoughnutChart />
            </div>
          </div>
        </Col>

        {/* Monthly TDS Trend */}
        <Col lg={4} className="mb-3">
          <div className="emp-tds-card min-height-300-px">
            <h3 className="chart-title color-white">Monthly TDS Trend</h3>
            <LineChart />
          </div>
        </Col>

        {/* Summary Panel */}
        <Col lg={4} className="mb-3">
          <div className="emp-tds-card min-height-300-px">
            <h3 className="chart-title color-white mb-3">Summary</h3>
            <div className="summary-content">
              <div className="info-row">
                <span className="info-label">Declared Income</span>
                <span className="color-white">₹12,00,000</span>
              </div>
              <div className="info-row">
                <span className="info-label">Taxable Income</span>
                <span className="color-white">₹8,70,000</span>
              </div>
              <div className="info-row">
                <span className="info-label">TDS Paid to Date</span>
                <span className="color-white">₹64,224</span>
              </div>
              <div className="info-row">
                <span className="info-label">Refund/Payable</span>
                <span className="color-white">₹0</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Employee Actions Section */}
      <h3 className='color-white font-weight-200 mb-3'>Employee Actions</h3>
      <Row>
        <Col sm="4">
          <div className="emp-tds-card">
            <div className="action-item">
              <div className="action-button upload">
                <Upload class_name={"text-white font-20"}/>
              </div>
              <h4 className="action-title color-white">Upload More Proofs</h4>
              <p className="action-description">Submit additional documents</p>
            </div>
          </div>
        </Col>
        <Col sm="4">
          <div className="emp-tds-card">
            <div className="action-item">
              <div className="action-button recalculate">
                <Calculator class_name={"text-white font-20"} />
              </div>
              <h4 className="action-title color-white">Request Recalculation</h4>
              <p className="action-description">Trigger TDS recalculation</p>
            </div>
          </div>
        </Col>
        <Col sm="4">
          <div className="emp-tds-card">
            <div className="action-item">
              <div className="action-button signature">
               <Signature class_name={"text-white font-20"} />
              </div>
              <h4 className="action-title color-white">Digital Signature</h4>
              <p className="action-description">Finalize declaration</p>
            </div>
          </div>
        </Col>
        {/* <Col>
          <Card className="emp-tds-card ">
            <Card.Body>
              <Card.Title className="actions-title color-white">Employee Actions</Card.Title>
              <div className="actions-container">
                <div className="action-item">
                  <div className="action-button upload">
                    <svg className="action-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                  </div>
                  <h4 className="action-title color-white">Upload More Proofs</h4>
                  <p className="action-description">Submit additional documents</p>
                </div>

                <div className="action-item">
                  <div className="action-button recalculate">
                    <svg className="action-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  </div>
                  <h4 className="action-title color-white">Request Recalculation</h4>
                  <p className="action-description">Trigger TDS recalculation</p>
                </div>

                <div className="action-item">
                  <div className="action-button signature">
                    <svg className="action-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h4 className="action-title color-white">Digital Signature</h4>
                  <p className="action-description">Finalize declaration</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col> */}
      </Row>
    </div>
  )
}

export default Overview